import React from 'react'

import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { Button, IconButton, Tooltip } from '@mui/material'
import { useCustomerEnrichApiKey } from 'features/customers/hooks/useCustomerEnrichApiKey'
import { useCustomerEnrichApiQuotaReset } from 'features/customers/hooks/useCustomerEnrichApiQuotaReset'

const CustomerEnrichApiQuotaResetButton = ({ compact }: { compact?: boolean }) => {
  const { data: apiKeys } = useCustomerEnrichApiKey()
  const { mutate: resetQuota } = useCustomerEnrichApiQuotaReset()

  const hasApiKey = !!apiKeys
  const reset = () => resetQuota()

  const button = compact ? (
    <IconButton aria-label="Reset Enrich API usage" disabled={!hasApiKey} onClick={reset} size="small">
      <RestartAltIcon fontSize="small" />
    </IconButton>
  ) : (
    <Button color="primary" disabled={!hasApiKey} onClick={reset}>
      Reset usage
    </Button>
  )

  return (
    <Tooltip title={hasApiKey ? "Reset this month's Enrich API usage" : 'Customer has no Enrich API'}>
      <span>{button}</span>
    </Tooltip>
  )
}

export default CustomerEnrichApiQuotaResetButton
